import React from 'react';
import { useRive } from "@rive-app/react-canvas";

export const Rive = ({src}) => {
    const { RiveComponent } = useRive({
        src: src,
        autoplay: true,
    })
    return <RiveComponent  />
}